import {useTranslation} from "react-i18next";

export default function useTranslationCustom({prefix = '', nameSpace = 'translation'}) {
  const {t, i18n} = useTranslation(nameSpace, {keyPrefix: prefix});
  return {t, i18n}
}
